module.exports = __webpack_public_path__ + "static/index/img/baikal-900.48626995.jpg";